// error-mapper.js
// Traduz erros do axios em mensagens amigáveis pro usuário.

export function mapApiError(err) {
  const isTimeout = err && err.code === 'ECONNABORTED';
  if (isTimeout) {
    return {
      title: 'Demorou demais',
      message:
        'O servidor demorou para responder. Tente novamente em alguns segundos. Se o problema persistir, verifique sua conexão.',
    };
  }

  const r = err && err.response;
  if (!r) {
    return {
      title: 'Falha de conexão',
      message:
        'Não foi possível se comunicar com o servidor. Confira sua internet ou tente mais tarde.',
    };
  }

  const status = r.status;
  const data = r.data || {};
  const cid = data.correlationId ? ` (código: ${data.correlationId})` : '';
  const raw = `${data.title || ''} ${data.message || ''}`.trim();

  // Casos específicos que você já conhece do back:
  if (/CONFLITO_INTEGRACAO/i.test(raw)) {
    return {
      title: 'Conflito de integração',
      message:
        'Já existe um pedido no Omie com esse código de integração. Verifique se o pedido já foi criado e evite reenviar.' +
        cid,
    };
  }
  if (/Pedido já cadastrado para o Código de Integração/i.test(raw)) {
    return {
      title: 'Pedido já existe no Omie',
      message:
        'Detectamos que esse pedido já está cadastrado no Omie. Atualize a página de pedidos para confirmar o vínculo.' +
        cid,
    };
  }

  switch (status) {
    case 400:
      // Validação / regra de negócio
      return {
        title: data.title || 'Não foi possível salvar',
        message:
          data.message ||
          'Alguns dados estão inválidos. Revise o formulário e tente novamente.' +
            cid,
      };
    case 409:
      return {
        title: 'Conflito',
        message:
          'O registro foi alterado por outro usuário ou conflitou. Recarregue a página e tente de novo.' +
          cid,
      };
    case 422:
      return {
        title: 'Dados inconsistentes',
        message:
          'Há inconsistências nos dados enviados. Corrija-as e envie novamente.' +
          cid,
      };
    case 500:
      return {
        title: 'Erro interno',
        message:
          'Tivemos um problema ao processar sua solicitação. Tente novamente em instantes.' +
          cid,
      };
    case 502:
    case 503:
    case 504:
      return {
        title: 'Servidor indisponível',
        message:
          'O serviço está instável no momento. Aguarde um pouco e tente novamente.' +
          cid,
      };
    default:
      return {
        title: data.title || 'Falha ao processar',
        message:
          (data.message && `${data.message}${cid}`) ||
          `Ocorreu um erro inesperado${cid}.`,
      };
  }
}
